export default __webpack_public_path__ + "static/media/card3.3be6f43e.jpeg";